import { atom, useAtom } from 'jotai';

// bool for toggling the side FAQ
export const selectedQuestionAtom = atom(undefined);

export function useSelectedQuestionAtom() {
  return useAtom(selectedQuestionAtom);
}
